<template>
  <div class="register-page-container" id="banner">
    <div class="register-form-container">
      <jt-register-form
        class="register-form"
        id="registerform"
        :game="game"
        :tag="tag"
        :errMessage="errMessage"
        :zhuti="zhuti"
        @signup="register"
      ></jt-register-form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import jtRegisterForm from './jtRegisterForm'
import GameModel from '../../models/game'
import UserModel from '../../models/user'
import * as constants from '../../constants'
import * as storage from '../../utils/storage'

export default {
  name: 'Register',
  components: {
    jtRegisterForm,
  },
  data() {
    return {
      game: {},
      errMessage: '',
      zhuti: '',
      tips: '',
      tag: null,
    }
  },
  methods: {
    async register(registerInfo) {
      const teamid = await UserModel.register(registerInfo)
      if (teamid) {
        let con = this.$t('jtRegisterPage.REGISTERSUCCESS')
        let title = this.$t('global.TIPS')
        let ok = this.$t('jtRegisterPage.OK')
        con = this.tips ? this.tips : con
        this.$alert(con, title, {
          confirmButtonText: ok,
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            this.toLogin(registerInfo.username)
          },
        })
      }
    },
    toLogin(username) {
      const router = this.$router
      if (!this.tag) {
        router.push({
          path: '/login.html',
          query: {
            gameId: this.game.id,
          },
        })
      }
    },
  },
  async mounted() {
    const router = this.$router
    const gameId = router.history.current.query.gameId
    const tag = router.history.current.query.tag
    this.gameId = gameId
    if (gameId == null) {
      this.$message.error(this.$t('jtRegisterPage.GAME_ID_IS_NULL'))
      router.push('/login.html')
      return
    } else {
      const data = await UserModel.registercheck(gameId)
      if (data.errNo === 0) {
        this.zhuti = data.payload ? data.payload['注册主体'] : ''
        this.tips = data.payload ? data.payload['注册提示'] : ''
      } else {
        this.errMessage = data.errMsg
      }
    }
    let gameList = storage.getItem(constants.GAME_LIST)
    
    if (tag) {
      let obj = await GameModel.getGameList(false)
      gameList = obj.gamelist
      this.$root.DOMAINNAME = obj.domainName
      let logo = obj.logo ? obj.logo : 1
      storage.setItem(constants.LOGO, logo)
      this.tag = tag
    }
    
    // this.game = await GameModel.getGameDetailByGameId(gameId)
    this.game = _.find(gameList, (item) => item.id === parseInt(gameId))
    
    if (storage.getItem('bannerUrl')) {
      let ele = document.getElementById('registerform')
      ele.style.border = 'none'
      ele.style.backgroundColor = 'rgba(255, 255, 255, 0.5)'
    }
  },
}
</script>

<style lang="stylus" scoped>
.register-page-container {
  width: 100%;
  height: 100%;

  div.bread-crumb {
    padding: 1em;
  }

  .register-form-container {
    min-height: calc(100% - 3em);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .register-form {
    width: 45%;
    background-color: #fff;
    border: 2px solid gray;
    border-radius: 6px;
  }
}

@media screen and (max-width: 768px) {
  .register-page-container {
    .register-form {
      width: 90%;
    }
  }
}
</style>
